<template>
	<TeamContactsList ref="teamContactsList" />
</template>

<script>
import TeamContactsList from "@/components/team/TeamContactsList";

export default {
	components: {
		TeamContactsList
	},
	data() {
		return {};
	},
	methods: {
		// languageChanged() {
		// 	this.$refs.playersList.refreshPlayerList();
		// },
		// refreshPlayerList() {
		// 	this.$refs.playersList.refreshPlayerList();
		// },
		// showAddPlayerProfile() {
		// 	this.$refs.addPlayerProfile.showAddPlayer();
		// },
		// updateTotalPlayers(count) {
		// 	this.totalPlayers = count;
		// }
	}
};
</script>

<style>
</style>